// src/services/authService.ts
import axios from "axios";

const API_URL = "https://portfoliom-backend.vercel.app/auth";

const getToken = () => localStorage.getItem("token");

export const getAllUsers = async () => {
    try {
        const token = getToken();
        const res = await axios.get(`${API_URL}/users`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return res.data; // { success: boolean, users: User[] }
    } catch (err: any) {
        console.error(err);
        throw new Error(err.response?.data?.message || "Kullanıcılar alınamadı");
    }
};